export const activeCountStyles = theme => ({
  color: theme.palette.primary.dark,
  cursor: 'default',
  marginTop: 2,
});

export const addNewButtonStyles = theme => ({
  marginLeft: theme.spacing(3),
});

export const filterCounterStyles = theme => ({
  alignItems: 'center',
  backgroundColor: theme.palette.primary.light,
  borderRadius: 2,
  color: theme.palette.primary.main,
  display: 'flex',
  fontSize: 12,
  height: 16,
  justifyContent: 'center',
  marginLeft: theme.spacing(1),
  padding: 2,
  width: 14,
});

export const headerActionsStyles = theme => ({
  marginRight: theme.spacing(1),
});

export const horizontalLineStyles = {
  height: '100%',
  width: 2,
};

export const marginRightBtnsStyles = theme => ({
  marginRight: theme.spacing(3),
});

export const tabTitleStyles = theme => ({
  color: theme.palette.primary.main,
  fontSize: 16,
  lineHeight: 1.5,
  padding: 0,
});
